// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.card[data-v-1fcef4a0]{\r\n\theight: 500px;\r\n\tmax-height: 90vh;\n}\n.list[data-v-1fcef4a0]{\r\n\t-webkit-box-flex: 1;\r\n\t    -ms-flex-positive: 1;\r\n\t        flex-grow: 1;\n}\n.button-bar[data-v-1fcef4a0]{\r\n\tpadding: 10px 15px;\n}\r\n\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
